import { render, staticRenderFns } from "./DemoSubView.vue?vue&type=template&id=2acfe8a9&scoped=true"
import script from "./DemoSubView.vue?vue&type=script&lang=js"
export * from "./DemoSubView.vue?vue&type=script&lang=js"
import style0 from "./DemoSubView.vue?vue&type=style&index=0&id=2acfe8a9&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acfe8a9",
  null
  
)

export default component.exports